module.exports = __webpack_public_path__ + "static/media/reference-list-icon.29a6b96c.svg";